import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import './sync-component.scss';
import {
  changeSyncComponentSearch,
  REDUCER_NAME as COMMON_REDUCER_NAME,
  setSyncComponent,
} from '../../app/commonReducer';
import {
  getDefaultSyncType,
  saveLastComponentSyncType,
} from '../../helpers/Common';
import {
  TYPE_BLUE,
  TYPE_DISABLE,
  TYPE_GREEN,
  TYPE_ORANGE,
  TYPE_PURPLE,
  TYPE_RED,
} from './Const';

const COLORS = {
  BLUE: '#1d97ef',
  PURPLE: '#7f48e5',
  GREEN: '#00ca75',
  RED: '#fa636d',
  ORANGE: '#fb7556',
  DISABLE: '#48566e',
};

const MAP_COLOR = {
  [TYPE_BLUE]: COLORS.BLUE,
  [TYPE_PURPLE]: COLORS.PURPLE,
  [TYPE_GREEN]: COLORS.GREEN,
  [TYPE_RED]: COLORS.RED,
  [TYPE_ORANGE]: COLORS.ORANGE,
  [TYPE_DISABLE]: COLORS.DISABLE,
};

const icons = [
  {
    color: '#1d97ef',
    type: TYPE_BLUE,
  },
  {
    color: '#7f48e5',
    type: TYPE_PURPLE,
  },
  {
    color: '#00ca75',
    type: TYPE_GREEN,
  },
  {
    color: '#fa636d',
    type: TYPE_RED,
  },
  {
    color: '#fb7556',
    type: TYPE_ORANGE,
  },
  {
    color: '#48566e',
    type: TYPE_DISABLE,
  },
];

class SyncComponent extends PureComponent {
  div = document.createElement('div');
  listRef = React.createRef();
  rootRef = React.createRef();
  state = {
    isShowList: false,
  };

  componentDidMount() {
    document.body.appendChild(this.div);
    const syncType = this.getType();
    const { componentName, setSyncComponent, componentId } = this.props;
    setSyncComponent({
      name: componentName,
      id: componentId,
      data: syncType,
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isShowList } = this.state;
    if (isShowList && !prevState.isShowList) {
      document.body.addEventListener('mousemove', this.onMouseMove);
      document.body.addEventListener('click', this.onClickOutside);
    }

    if (!isShowList && prevState.isShowList) {
      document.body.removeEventListener('mousemove', this.onMouseMove);
      document.body.removeEventListener('click', this.onClickOutside);
    }
  }

  componentWillUnmount() {
    document.body.removeChild(this.div);
    document.body.removeEventListener('mousemove', this.onMouseMove);
    document.body.removeEventListener('click', this.onClickOutside);
  }

  onMouseMove = e => {
    const isInList =
      this.listRef.current && this.listRef.current.contains(e.target);
    if (isInList || this.rootRef.current.contains(e.target)) {
      return;
    }
    this.setState({
      isShowList: false,
    });
  };

  onClickOutside = e => {
    if (this.listRef.current.contains(e.target)) {
      return;
    }
    this.setState({
      isShowList: false,
    });
  };

  changeSyncType = (type, e) => {
    e.preventDefault();
    e.stopPropagation();
    const {
      componentName,
      setSyncComponent,
      componentId,
      syncComponentSearch,
      changeSyncComponentSearch,
    } = this.props;
    const oldType = this.getType();
    setSyncComponent({
      name: componentName,
      id: componentId,
      data: type,
    });
    this.setState({
      isShowList: false,
    });
    saveLastComponentSyncType(componentName, type);
    if (oldType === type) {
      return;
    }
    const oldSearch = syncComponentSearch[oldType];
    changeSyncComponentSearch({
      syncType: type,
      search: oldSearch,
    });
  };

  renderSyncType = () => {
    if (!this.rootRef.current) {
      return null;
    }
    const { top, left } = this.rootRef.current.getBoundingClientRect();

    return (
      <div
        ref={this.listRef}
        style={{ top: top + 20, left }}
        className="sync-type"
      >
        {icons.map((icon, index) => (
          <div
            onClick={e => this.changeSyncType(icon.type, e)}
            key={index}
            style={{ backgroundColor: icon.color }}
            className={`sync-icon ${
              icon.type === TYPE_DISABLE ? 'disabled' : ''
            }`}
          >
            <i className="icon-link" />
          </div>
        ))}
      </div>
    );
  };

  getType = () => {
    const { componentId, syncState, componentName } = this.props;

    return syncState[componentId] || getDefaultSyncType(componentName);
  };

  onMouseEnter = e => {
    this.setState({
      isShowList: true,
    });
  };

  onClick = () => {
    this.setState({
      isShowList: true,
    });
  };

  render() {
    const { isShowList } = this.state;

    return (
      <div
        style={{
          backgroundColor: MAP_COLOR[this.getType()],
        }}
        ref={this.rootRef}
        onMouseEnter={this.onMouseEnter}
        onClick={this.onClick}
        className={`sync-component ${
          this.getType() === TYPE_DISABLE ? 'disabled' : ''
        }`}
      >
        <i className="icon-link" />

        {isShowList && ReactDOM.createPortal(this.renderSyncType(), this.div)}
      </div>
    );
  }
}

SyncComponent.propTypes = {
  componentName: PropTypes.string.isRequired,
  componentId: PropTypes.number.isRequired,
  setSyncComponent: PropTypes.func.isRequired,
  syncState: PropTypes.object.isRequired,
};

const mapStateToProps = (state, { componentName }) => ({
  syncState: state[COMMON_REDUCER_NAME].syncComponent[componentName] || {},
  syncComponentSearch: state[COMMON_REDUCER_NAME].syncComponentSearch,
});

const mapDispatchToProps = {
  setSyncComponent,
  changeSyncComponentSearch,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SyncComponent);
